import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { OrganisationService } from "../../services/organisation.service";
import { organisationActions } from "./organisation.actions";

@Injectable()
export class OrganisationEffects {

    private readonly action$ = inject(Actions);
    private readonly organisationService = inject(OrganisationService);

    loadFromApiOrganisation$ = createEffect(() => {
        return this.action$.pipe(
            ofType(organisationActions["[Organisation-API]LoadOrganisation"]),
            switchMap((payload) => this.organisationService.getOrganisations(payload.payload).pipe(
                map(organisationResponse => organisationActions["[Organisation-API]LoadSuccess"](organisationResponse)),
                catchError((organisationResponse) => of(organisationActions["[Organisation-API]LoadFailed"](organisationResponse)))
            ))
        )
    })

    createOrganisation$ = createEffect(() => {
        return this.action$.pipe(
            ofType(organisationActions['createOrganisation']),
            switchMap((payload) => this.organisationService.createOrganisation(payload.payload).pipe(
                map(organisationResponse => organisationActions["created"](organisationResponse)),
                catchError((organisationResponse) => of(organisationActions["createFailed"](organisationResponse)))
            ))
        )
    })
}